document.addEventListener('DOMContentLoaded', function () {

    // GLIGHTBOX
    if (typeof GLightbox !== 'undefined' && document.querySelector('.glightbox')) {
        GLightbox({
            selector: '.glightbox',
            touchNavigation: true,
            loop: true
        });
    }

    // MOBILE MENU
    // Below 960px the header links collapse into a burger panel (_header.scss).
    var nav = document.querySelector('.vacancy-nav');
    var burger = nav && nav.querySelector('.vacancy-nav__burger');

    if (nav && burger) {
        /**
         * Open or close the mobile navigation panel.
         *
         * @param {boolean} open Whether the panel should be visible.
         * @return {void}
         */
        var setMenu = function (open) {
            nav.classList.toggle('vacancy-nav--open', open);
            burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        };

        burger.addEventListener('click', function () {
            setMenu(!nav.classList.contains('vacancy-nav--open'));
        });

        // The links are in-page anchors, so the panel has to get out of the way
        // once one is used, otherwise it covers the section it just scrolled to.
        nav.querySelectorAll('.vacancy-nav__links a').forEach(function (link) {
            link.addEventListener('click', function () { setMenu(false); });
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') { setMenu(false); }
        });
    }

    // BOTTOM BAR
    // While the hero is visible it already has its own mini-form — the bar
    // would be a second identical CTA in the same frame. Show it after the hero.
    var hero = document.querySelector('.vacancy-hero');

    if (hero) {
        if ('IntersectionObserver' in window) {
            new IntersectionObserver(function (entries) {
                document.body.classList.toggle('is-past-hero', !entries[0].isIntersecting);
            }, { rootMargin: '-40% 0px 0px 0px' }).observe(hero);
        } else {
            document.body.classList.add('is-past-hero');
        }
    } else {
        document.body.classList.add('is-past-hero');
    }

    // SCROLL-IN ANIMATIONS
    // Each element with data-anim gets a reveal variant; siblings inside the
    // same container cascade in via --reveal-i.
    var animated = document.querySelectorAll('[data-anim]');

    if (animated.length) {
        var motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!motionOk || !('IntersectionObserver' in window)) {
            animated.forEach(function (el) { el.classList.add('is-in'); });
        } else {
            var groups = new Map();

            animated.forEach(function (el) {
                el.classList.add('vacancy-reveal', 'vacancy-reveal--' + (el.getAttribute('data-anim') || 'up'));

                var parent = el.parentElement;
                var index = groups.get(parent) || 0;
                groups.set(parent, index + 1);
                el.style.setProperty('--reveal-i', Math.min(index, 6));
            });

            var io = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-in');
                        io.unobserve(entry.target);
                    }
                });
            }, { threshold: .1, rootMargin: '0px 0px -8% 0px' });

            animated.forEach(function (el) { io.observe(el); });
        }
    }

    // FORM SUBMIT INDICATOR
    // CF7's built-in spinner is a grey circle under the form. Wrap the button
    // instead, to show the loading state right inside it (animation in _submit.scss).
    document.querySelectorAll('.wpcf7-form input[type="submit"]').forEach(function (submit) {
        if (submit.parentNode.classList.contains('vacancy-submit')) return;

        var wrap = document.createElement('span');
        wrap.className = 'vacancy-submit';
        submit.parentNode.insertBefore(wrap, submit);
        wrap.appendChild(submit);
    });

});
